import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=6ae3b612&"
import script from "./UserDisplay.vue?vue&type=script&lang=js&"
export * from "./UserDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae3b612')) {
      api.createRecord('6ae3b612', component.options)
    } else {
      api.reload('6ae3b612', component.options)
    }
    module.hot.accept("./UserDisplay.vue?vue&type=template&id=6ae3b612&", function () {
      api.rerender('6ae3b612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserDisplay.vue"
export default component.exports